import { Form, Radio } from 'antd';
import Text from 'components/Text/Text';
import { TEditTeaserTransitionType } from 'modules/Teasers/EditTeaser/editTeaserState/editTeaserContext';
import React, { MouseEvent } from 'react';
import style from './TransitionTypeSwitch.module.scss';

interface ITransitionTypeSwitch {
	setTransitionType: (value: TEditTeaserTransitionType) => void;
}

const TransitionTypeSwitch: React.FC<ITransitionTypeSwitch> = ({ setTransitionType }) => {
	const handleChange = (e: MouseEvent<HTMLInputElement>) => {
		setTransitionType(e.currentTarget.value as TEditTeaserTransitionType);
	};

	return (
		<Form.Item name="selectedTransitionType" className={style.formItem}>
			<Radio.Group>
				<Radio value="dish" onClick={handleChange}>
					<Text translationNameSpace="form" translationKey="dishLabel" asFragment={true} />
				</Radio>
				<Radio value="game" onClick={handleChange}>
					<Text translationNameSpace="form" translationKey="gameLabel" asFragment={true} />
				</Radio>
			</Radio.Group>
		</Form.Item>
	);
};

export default React.memo(TransitionTypeSwitch);
